import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { CheckIcon, ClipboardIcon } from '@heroicons/react/24/outline';

// Middle names for Homa Bay & Migori (100 Luo names)
const homabayMigoriMiddleNames = [
  "Otieno", "Omondi", "Ochieng", "Odhiambo", "Onyango", "Owuor", "Okeyo", "Ochola", "Obonyo", "Oburu",
  "Ouma", "Ogwang", "Omuga", "Rao", "Rawo", "Jow", "Nyang'au", "Oliech", "Otula", "Orweno", "Magero",
  "Julu", "Kidenda", "Kowa", "Hongo", "Oronge", "Oruoch", "Osuri", "Yienya", "Sialo", "Were",
  "Odiek", "Ooko", "Ogalo", "Omolo", "Owino", "Odalo", "Oduko", "Okumu", "Gor", "Jalang'o",
  "Meyo", "Ndiege", "Onango", "Obuo", "Ochuka", "Odede", "Raila", "Ramogi", "Ondiek", "Owiti",
  "Oloo", "Ogonji", "Odhon'g", "Odek", "Oduor", "Odongo", "Ouma", "Ogweyo", "Omuga", "Rao",
  "Rawo", "Jow", "Nyang'au", "Oliech", "Otula", "Orweno", "Hera", "Magero", "Julu", "Kidenda",
  "Kowa", "Hongo", "Oronge", "Oruoch", "Osuri", "Yienya", "Sialo", "Were", "Odiek", "Ooko",
  "Ogalo", "Omolo", "Owino", "Odalo", "Oduko", "Okumu", "Adida", "Ahenda", "Ajek", "Gor"
];

// FEMALE FIRST NAMES
const femaleFirstNames = [
  "Faith", "Grace", "Mercy", "Joy", "Hope", "Mary", "Esther", "Ruth", "Naomi", "Sarah", "Rebecca", "Lydia", "Hannah", "Martha", "Agnes", "Lucy", "Irene", "Susan", "Pauline", "Janet", "Alice", "Beatrice", "Florence", "Christine", "Sheila", "Caroline", "Diana", "Linda", "Veronica", "Monica", "Brenda", "Angela", "Nancy", "Violet", "Sharon", "Rose", "Achieng", "Atieno", "Moraa", "Kerubo", "Sylvia", "Winnie", "Patricia", "Jacqueline",
  "Zuri"
];

// MALE FIRST NAMES
const maleFirstNames = [
  "John", "James", "Peter", "Paul", "David", "Joseph", "Daniel", "Samuel", "Michael", "Andrew", "Stephen", "Thomas", "Robert", "Francis", "George", "William", "Charles", "Kevin", "Brian", "Eric", "Dennis", "Victor", "Martin", "Simon", "Nicholas", "Evans", "Alfred", "Patrick", "Kennedy", "Leonard", "Moses", "Benjamin", "Ochieng", "Mose", "Alex", "Raymond",
  "Zane"
];

// Postal codes and areas for Kisii County
const kisiiPostalAreas = [
  { area: "Kisii", code: "40200" },
  { area: "Gesusu", code: "40201" },
  { area: "Keroka", code: "40202" },
  { area: "Nyamache", code: "40203" },
  { area: "Ogembo", code: "40204" },
  { area: "Nyambunwa", code: "40205" },
  { area: "Nyamarambe", code: "40206" },
  { area: "Etago", code: "40208" },
  { area: "Igare", code: "40209" },
  { area: "Itumbe", code: "40210" },
  { area: "Kenyenya", code: "40211" },
  { area: "Keumbu", code: "40212" },
  { area: "Kiamokama", code: "40213" },
  { area: "Marani", code: "40214" },
  { area: "Masimba", code: "40215" },
  { area: "Nyangusu", code: "40218" },
  { area: "Riosiri", code: "40220" },
  { area: "Tabaka", code: "40229" },
  { area: "Nyaramba", code: "40514" },
  { area: "Kegogi", code: "40515" },
  { area: "Magena", code: "40516" }
];

// Postal codes and areas for Homa Bay County
const homabayPostalAreas = [
  { area: "Oyugis", code: "40222" },
  { area: "Kadongo", code: "40223" },
  { area: "Homa Bay", code: "40300" },
  { area: "Kendu Bay", code: "40301" },
  { area: "Ndhiwa", code: "40302" },
  { area: "Rangwe", code: "40303" },
  { area: "Kandiege", code: "40304" },
  { area: "Mbita", code: "40305" },
  { area: "Ombonga", code: "40306" },
  { area: "Magunga", code: "40307" },
  { area: "Sindo", code: "40308" },
  { area: "Asumbi", code: "40309" },
  { area: "Mawego", code: "40310" },
  { area: "Nyangweso", code: "40311" },
  { area: "Kojwang", code: "40317" },
  { area: "Mfangano", code: "40319" },
  { area: "Mirogi", code: "40320" },
  { area: "Ogongo", code: "40323" },
  { area: "Rodi Kopany", code: "40326" },
  { area: "Awach Tende", code: "40328" },
  { area: "Pala / Rusinga", code: "40329" },
  { area: "Kosele", code: "40332" },
  { area: "Nyandhiwa", code: "40333" },
  { area: "Oyani‑Masi", code: "40334" },
  { area: "Asego", code: "40335" }
];

// Postal codes and areas for Migori County
const migoriPostalAreas = [
  { area: "Migori (town and Suna)", code: "40400" },
  { area: "Rapogi", code: "40403" },
  { area: "Rongo", code: "40404" },
  { area: "Awendo / Sare", code: "40405" },
  { area: "Giribe", code: "40407" },
  { area: "Mukuro", code: "40410" },
  { area: "Kehancha", code: "40413" },
  { area: "Isibania", code: "40414" },
  { area: "Kegonga", code: "40416" },
  { area: "Ntimaru", code: "40417" },
  { area: "Suba‑Kuria", code: "40418" },
  { area: "Ikerege", code: "40415" }
];

// Helper to assign underlying illness with 23% probability
function assignUnderlyingIllness() {
  const illnessList = [
    "Hypertension",
    "Diabetes Mellitus",
    "Asthma",
    "HIV",
    "Epilepsy",
    "Sickle Cell Disease",
    "Chronic Kidney Disease",
    "Heart Disease",
    "Peptic Ulcer Disease"
  ];
  if (Math.random() < 0.23) {
    return illnessList[Math.floor(Math.random() * illnessList.length)];
  }
  return "None";
}

// Address generator
function generateAddress(county) {
  let areaList;
  if (county === "Kisii") {
    areaList = kisiiPostalAreas;
  } else if (county === "Homa Bay") {
    areaList = homabayPostalAreas;
  } else if (county === "Migori") {
    areaList = migoriPostalAreas;
  } else {
    // fallback: random county
    const counties = [kisiiPostalAreas, homabayPostalAreas, migoriPostalAreas];
    areaList = counties[Math.floor(Math.random() * counties.length)];
  }
  const areaObj = areaList[Math.floor(Math.random() * areaList.length)];
  const poBox = Math.floor(Math.random() * 998) + 2; // realistic P.O. Box number (2–999)
  return {
    poBox,
    postalCode: areaObj.code,
    subCounty: areaObj.area, // always use the mapped sub-county name
    county
  };
}

// Homa Bay & Migori last names with gender
const homabayLastNames = [
  {name: "Ochieng", gender: "male"}, {name: "Achieng", gender: "female"}, {name: "Odhiambo", gender: "male"}, {name: "Adhiambo", gender: "female"}, {name: "Onyango", gender: "male"}, {name: "Anyango", gender: "female"}, {name: "Otieno", gender: "male"}, {name: "Atieno", gender: "female"}, {name: "Omondi", gender: "male"}, {name: "Amondi", gender: "female"}, {name: "Owuor", gender: "male"}, {name: "Awuor", gender: "female"}, {name: "Okeyo", gender: "male"}, {name: "Akeyo", gender: "female"}, {name: "Apiyo", gender: "male"}, {name: "Adongo", gender: "female"}, {name: "Ochola", gender: "male"}, {name: "Achola", gender: "female"}, {name: "Obonyo", gender: "male"}, {name: "Abonyo", gender: "female"}, {name: "Oburu", gender: "male"}, {name: "Aburu", gender: "female"}, {name: "Akoth", gender: "female"}, {name: "Aoro", gender: "female"}, {name: "Akomo", gender: "female"}, {name: "Awiti", gender: "female"}, {name: "Awino", gender: "female"}, {name: "Akello", gender: "female"}, {name: "Aruma", gender: "female"}, {name: "Obiero", gender: "male"}, {name: "Abiero", gender: "female"}, {name: "Odhon’g", gender: "male"}, {name: "Adhon’g", gender: "female"}, {name: "Odek", gender: "male"}, {name: "Adek", gender: "female"}, {name: "Oduor", gender: "male"}, {name: "Aduor", gender: "female"}, {name: "Odongo", gender: "male"}, {name: "Apio", gender: "female"}, {name: "Akinyi", gender: "female"}, {name: "Ouma", gender: "male"}, {name: "Auma", gender: "female"}, {name: "Ogwang", gender: "male"}, {name: "Ogweyo", gender: "male"}, {name: "Omuga", gender: "male"}, {name: "Rao", gender: "male"}, {name: "Rawo", gender: "male"}, {name: "Jow", gender: "male"}, {name: "Nyang'au", gender: "male"}, {name: "Oliech", gender: "male"}, {name: "Otula", gender: "male"}, {name: "Orweno", gender: "male"}, {name: "Hera", gender: "female"}, {name: "Magero", gender: "male"}, {name: "Julu", gender: "male"}, {name: "Kidenda", gender: "male"}, {name: "Kowa", gender: "male"}, {name: "Hongo", gender: "male"}, {name: "Oronge", gender: "male"}, {name: "Oruoch", gender: "male"}, {name: "Osuri", gender: "male"}, {name: "Yienya", gender: "male"}, {name: "Sialo", gender: "male"}, {name: "Were", gender: "male"}, {name: "Odiek", gender: "male"}, {name: "Ooko", gender: "male"}, {name: "Ogalo", gender: "male"}, {name: "Omolo", gender: "male"}, {name: "Owino", gender: "male"}, {name: "Odalo", gender: "male"}, {name: "Oduko", gender: "male"}, {name: "Okumu", gender: "male"}, {name: "Adida", gender: "female"}, {name: "Ahenda", gender: "female"}, {name: "Ajek", gender: "female"}, {name: "Gor", gender: "male"}, {name: "Jalang'o", gender: "male"}, {name: "Meyo", gender: "male"}, {name: "Ndiege", gender: "male"}, {name: "Onango", gender: "male"}, {name: "Obuo", gender: "male"}, {name: "Abuo", gender: "female"}, {name: "Ochuka", gender: "male"}, {name: "Achuka", gender: "female"}, {name: "Odede", gender: "male"}, {name: "Adede", gender: "female"}, {name: "Raila", gender: "male"}, {name: "Ramogi", gender: "male"}, {name: "Ondiek", gender: "male"}, {name: "Owiti", gender: "male"}, {name: "Owino", gender: "male"}, {name: "Ouma", gender: "male"}, {name: "Okumu", gender: "male"}, {name: "Oloo", gender: "male"}, {name: "Ogonji", gender: "male"}
];

const kisiiLastNames = [
  {name: "Nyabuto", gender: "female"}, {name: "Momanyi", gender: "male"}, {name: "Nyakundi", gender: "male"}, {name: "Makori", gender: "male"}, {name: "Ondieki", gender: "male"}, {name: "Moraa", gender: "female"}, {name: "Kerubo", gender: "female"}, {name: "Mose", gender: "male"}, {name: "Osoro", gender: "male"}, {name: "Bosire", gender: "female"}, {name: "Kwamboka", gender: "female"}, {name: "Mogaka", gender: "male"}, {name: "Ombati", gender: "male"}, {name: "Mokaya", gender: "female"}, {name: "Mokua", gender: "female"}, {name: "Morara", gender: "female"}, {name: "Mauti", gender: "male"}, {name: "Ogega", gender: "male"}, {name: "Nyaboke", gender: "female"}, {name: "Orina", gender: "female"}, {name: "Omari", gender: "male"}, {name: "Omwenga", gender: "male"}, {name: "Onsongo", gender: "male"}, {name: "Ongeri", gender: "male"}, {name: "Nyangaresi", gender: "female"}, {name: "Nyang'au", gender: "male"}, {name: "Nyamweya", gender: "male"}, {name: "Okemwa", gender: "male"}, {name: "Mogire", gender: "male"}, {name: "Nyagaka", gender: "female"}, {name: "Otieno", gender: "male"}, {name: "Morang'a", gender: "female"}, {name: "Ratemo", gender: "male"}, {name: "Nyangau", gender: "male"}, {name: "Ombui", gender: "male"}, {name: "Nyambane", gender: "female"}, {name: "Ombasa", gender: "male"}, {name: "Obara", gender: "male"}, {name: "Omwoyo", gender: "male"}, {name: "Bosibori", gender: "female"}, {name: "Onyancha", gender: "male"}, {name: "Moranga", gender: "female"}, {name: "Orenge", gender: "male"}, {name: "Omweri", gender: "male"}, {name: "Oyaro", gender: "male"}, {name: "Barongo", gender: "male"}, {name: "Onderi", gender: "male"}, {name: "Moseti", gender: "male"}, {name: "Okari", gender: "male"}, {name: "Omare", gender: "male"}, {name: "Masese", gender: "male"}, {name: "Mogere", gender: "male"}, {name: "Mochama", gender: "male"}, {name: "Onyango", gender: "male"}, {name: "Mageto", gender: "male"}, {name: "Abuga", gender: "male"}, {name: "Onduso", gender: "male"}, {name: "Maranga", gender: "female"}, {name: "Ondari", gender: "male"}, {name: "Onsare", gender: "male"}, {name: "Onyiego", gender: "male"}, {name: "Ndege", gender: "female"}, {name: "Osiemo", gender: "male"}, {name: "Mogeni", gender: "male"}, {name: "Gichana", gender: "male"}, {name: "Ntabo", gender: "male"}, {name: "Machuki", gender: "male"}, {name: "Obiri", gender: "male"}, {name: "Ondara", gender: "male"}, {name: "Mogusu", gender: "male"}, {name: "Nyanchama", gender: "female"}, {name: "Angwenyi", gender: "female"}, {name: "Kenyanya", gender: "female"}, {name: "Mayaka", gender: "female"}, {name: "Marube", gender: "male"}, {name: "Monari", gender: "male"}, {name: "Okindo", gender: "male"}, {name: "Ombaso", gender: "male"}, {name: "Isaboke", gender: "female"}, {name: "Matoke", gender: "male"}
];

const kisiiLocalNames = [
  "Nyabuto", "Momanyi", "Nyakundi", "Makori", "Ondieki", "Moraa", "Kerubo", "Mose", "Osoro", "Bosire",
  "Kwamboka", "Mogaka", "Ombati", "Mokaya", "Mokua", "Morara", "Mauti", "Ogega", "Nyaboke", "Orina",
  "Omari", "Omwenga", "Onsongo", "Ongeri", "Nyangaresi", "Nyang'au", "Nyamweya", "Okemwa", "Mogire",
  "Nyagaka", "Morang'a", "Ratemo", "Nyangau", "Ombui", "Nyambane", "Ombasa", "Obara", "Omwoyo",
  "Bosibori", "Onyancha", "Moranga", "Orenge", "Omweri", "Oyaro", "Barongo", "Onderi", "Moseti",
  "Okari", "Omare", "Masese", "Mogere", "Mochama", "Onyango", "Mageto", "Abuga", "Onduso", "Maranga",
  "Ondari", "Onsare", "Onyiego", "Ndege", "Osiemo", "Mogeni", "Gichana", "Ntabo", "Machuki", "Obiri",
  "Ondara", "Mogusu", "Nyanchama", "Angwenyi", "Kenyanya", "Mayaka", "Marube", "Monari", "Okindo",
  "Ombaso", "Isaboke", "Matoke", "Nyabera", "Nyamache", "Nyamwaro", "Nyamweno", "Nyabera", "Nyanchera",
  "Nyamwaro", "Nyamweno", "Nyabera", "Nyanchera", "Nyamwaro", "Nyamweno", "Nyabera", "Nyanchera",
  "Nyamwaro", "Nyamweno", "Nyabera", "Nyanchera", "Nyamwaro", "Nyamweno"
];

const mockPerson = {
  firstName: '',
  gender: '',
  middleName: '',
  lastName: '',
  dob: '',
  // nationalId will be generated dynamically based on age
  email: '',
  phone: '',
  county: '',
  subCounty: '',
  postalCode: '',
  poBox: '',
  illness: '',
};

const fieldOrder = [
  { key: 'firstName', label: 'First Name' },
  { key: 'middleName', label: 'Middle Name' },
  { key: 'lastName', label: 'Last Name' },
  { key: 'gender', label: 'Gender' },
  { key: 'dob', label: 'Date of Birth' },
  { key: 'nationalId', label: 'National ID' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone Number' },
  { key: 'county', label: 'County' },
  { key: 'subCounty', label: 'Sub-County' },
  { key: 'postalCode', label: 'Postal Code' },
  { key: 'poBox', label: 'P.O. Box' },
  { key: 'illness', label: 'Underlying Illness' },
];

// Modal for completed patients
function CompletedTableModal({ open, onClose, patients, title, showDateFilter, filterDate, setFilterDate }) {
  if (!open) return null;
  let filtered = patients;
  if (showDateFilter && filterDate) {
    filtered = patients.filter(p => {
      const d = new Date(p.completedAt);
      return d.toISOString().slice(0, 10) === filterDate;
    });
  }
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded shadow-lg p-6 w-full max-w-2xl relative">
        <button className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" onClick={onClose}>&times;</button>
        <h3 className="text-xl font-bold mb-4">{title}</h3>
        {showDateFilter && (
          <div className="mb-4">
            <label className="font-semibold mr-2">Filter by date:</label>
            <input type="date" value={filterDate} onChange={e => setFilterDate(e.target.value)} className="border rounded px-2 py-1" />
          </div>
        )}
        <div className="overflow-x-auto">
          <table className="min-w-full border">
            <thead>
              <tr>
                <th className="border px-2 py-1">Date</th>
                <th className="border px-2 py-1">First Name</th>
                <th className="border px-2 py-1">Middle Name</th>
                <th className="border px-2 py-1">Last Name</th>
                <th className="border px-2 py-1">Gender</th>
                <th className="border px-2 py-1">DOB</th>
                <th className="border px-2 py-1">National ID</th>
                <th className="border px-2 py-1">Email</th>
                <th className="border px-2 py-1">Phone</th>
                <th className="border px-2 py-1">Illness</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={10} className="text-center py-4">No records found.</td></tr>
              ) : (
                filtered.map((p, i) => (
                  <tr key={i}>
                    <td className="border px-2 py-1">{new Date(p.completedAt).toLocaleDateString()}</td>
                    <td className="border px-2 py-1">{p.firstName}</td>
                    <td className="border px-2 py-1">{p.middleName}</td>
                    <td className="border px-2 py-1">{p.lastName}</td>
                    <td className="border px-2 py-1">{p.gender}</td>
                    <td className="border px-2 py-1">{p.dob}</td>
                    <td className="border px-2 py-1">{p.nationalId}</td>
                    <td className="border px-2 py-1">{p.email}</td>
                    <td className="border px-2 py-1">{p.phone}</td>
                    <td className="border px-2 py-1">{p.underlying_illness || p.illness || 'None'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function UserDashboard({ loggedInHospital, onLogout }) {
  const navigate = useNavigate();
  const hospitalCountyMap = {
    'Ablecare Hospital': 'Kisii',
    'Saye Hospital': 'Homa Bay',
    'Malela Hospital': 'Migori',
    'A.A family hospital': 'Homa Bay',
    'Kendu Adventist Hospital': 'Homa Bay',
  };
  const hospitalOptions = Object.keys(hospitalCountyMap);
  // Use the logged-in hospital from props
  const selectedHospital = loggedInHospital || hospitalOptions[0];
  // Fetch completed patients for this hospital from backend
  const [completedPatients, setCompletedPatients] = useState([]);
  useEffect(() => {
    if (!selectedHospital) return;
    fetch(`https://zaidoc.lynmercan.com/api/patients.php?hospital=${encodeURIComponent(selectedHospital)}`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setCompletedPatients(data);
        else setCompletedPatients([]);
      })
      .catch(() => setCompletedPatients([]));
  }, [selectedHospital]);

  if (!window.generatedEmails) window.generatedEmails = new Set();
  if (!window.generatedIds) window.generatedIds = new Set();
  if (!window.generatedPhones) window.generatedPhones = new Set();

  const isDuplicateValue = (key, value) => {
    if (!value) return false;
    const normalized = key === 'email' ? String(value).toLowerCase() : String(value);
    const inCompleted = completedPatients.some(p => {
      const current = key === 'email' ? String(p[key] || '').toLowerCase() : String(p[key] || '');
      return current === normalized;
    });
    if (key === 'email') return inCompleted || window.generatedEmails.has(normalized);
    if (key === 'nationalId') return inCompleted || window.generatedIds.has(normalized);
    if (key === 'phone') return inCompleted || window.generatedPhones.has(normalized);
    return inCompleted;
  };

  const isDuplicateInCompleted = (key, value) => {
    if (!value) return false;
    const normalized = key === 'email' ? String(value).toLowerCase() : String(value);
    return completedPatients.some(p => {
      const current = key === 'email' ? String(p[key] || '').toLowerCase() : String(p[key] || '');
      return current === normalized;
    });
  };
  // Helper to get random item
  function getRandom(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  // Generate a random person for the selected county
  function generatePerson(county) {
    const underlying_illness = assignUnderlyingIllness();

    // Phone number generation with weighted prefixes and uniqueness
    const commonPrefixes = ["072", "071", "070"];
    const mediumPrefixes = ["011"];
    const rarePrefixes = ["078", "077", "073", "076", "074", "079", "075"];
    let prefixGroup;
    const rand = Math.random();
    if (rand < 0.65) {
      prefixGroup = commonPrefixes;
    } else if (rand < 0.80) {
      prefixGroup = mediumPrefixes;
    } else {
      prefixGroup = rarePrefixes;
    }
    let phone;
    do {
      const prefix = prefixGroup[Math.floor(Math.random() * prefixGroup.length)];
      const rest = String(Math.floor(Math.random() * 10000000)).padStart(7, '0');
      phone = prefix + rest;
    } while (isDuplicateValue('phone', phone));
    window.generatedPhones.add(phone);

    // Helper to generate realistic email
    function generateEmail(first, middle, last, dobYear) {
      // Realistic email patterns
      const cleanFirst = first.replace(/[^a-zA-Z]/g, '').toLowerCase();
      const cleanLast = last.replace(/[^a-zA-Z]/g, '').toLowerCase();
      const cleanMiddle = middle ? middle.replace(/[^a-zA-Z]/g, '').toLowerCase() : '';
      const patterns = [
        () => `${cleanFirst}.${cleanLast}`,
        () => `${cleanFirst}${cleanLast}`,
        () => `${cleanFirst[0]}${cleanLast}`,
        () => `${cleanFirst}${cleanLast}${dobYear}`,
        () => `${cleanFirst}.${cleanLast}${Math.floor(Math.random() * 100)}`,
        () => `${cleanFirst}${cleanMiddle ? '.' + cleanMiddle[0] : ''}.${cleanLast}`,
        () => `${cleanFirst}_${cleanLast}`,
      ];
      // Pick domain: gmail 85%, yahoo 10%, outlook 5%
      const rand = Math.random();
      let domain = 'gmail.com';
      if (rand > 0.85 && rand <= 0.95) domain = 'yahoo.com';
      else if (rand > 0.95) domain = 'outlook.com';
      let emailBase = patterns[Math.floor(Math.random() * patterns.length)]();
      // Remove repeated characters (max 2 in a row)
      emailBase = emailBase.replace(/([a-zA-Z])\1{2,}/g, '$1$1');
      // Remove spaces
      emailBase = emailBase.replace(/\s+/g, '');
      return `${emailBase}@${domain}`;
    }

    if (county === 'Homa Bay' || county === 'Migori') {
      const last = getRandom(homabayLastNames);
      const gender = last.gender.charAt(0).toUpperCase() + last.gender.slice(1);
      let firstName;
      if (gender === 'Female') {
        // Traditional Luo: Achieng, Atieno (20% chance)
        const traditional = ["Achieng", "Atieno"];
        if (Math.random() < 0.2) {
          firstName = getRandom(traditional);
        } else {
          firstName = getRandom(femaleFirstNames.filter(n => !["Moraa", "Kerubo"].includes(n)));
        }
      } else {
        // Traditional Luo: Ochieng (20% chance)
        const traditional = ["Ochieng"];
        if (Math.random() < 0.2) {
          firstName = getRandom(traditional);
        } else {
          firstName = getRandom(maleFirstNames.filter(n => n !== "Mose"));
        }
      }
      // Middle name is random from homabayMigoriMiddleNames
      const middleName = getRandom(homabayMigoriMiddleNames);
      // Generate DOB and ID logic based on year of birth
      // Restrict year to 1951–2008 (ages 18–75 in 2026, min age 18)
      const year = Math.floor(Math.random() * (2008 - 1951 + 1)) + 1951;
      const month = String(Math.floor(Math.random() * 12) + 1).padStart(2, '0');
      const day = String(Math.floor(Math.random() * 28) + 1).padStart(2, '0');
      const dob = `${day}/${month}/${year}`;
      // ID logic with probabilistic prefix selection based on age cohort
      // 1951–1955: 10–11
      // 1956–1965: 11–15
      // 1966–1975: 12–18
      // 1976–1985: 19–25
      // 1986–1995: 26–33
      // 1996–2005: 33–38
      // 2006–2008: 38
      let prefix;
      if (year >= 1951 && year <= 1955) {
        prefix = String(Math.floor(Math.random() * 2) + 10); // 10–11
      } else if (year >= 1956 && year <= 1965) {
        prefix = String(Math.floor(Math.random() * 5) + 11); // 11–15
      } else if (year >= 1966 && year <= 1975) {
        prefix = String(Math.floor(Math.random() * 7) + 12); // 12–18
      } else if (year >= 1976 && year <= 1985) {
        prefix = String(Math.floor(Math.random() * 7) + 19); // 19–25
      } else if (year >= 1986 && year <= 1995) {
        prefix = String(Math.floor(Math.random() * 8) + 26); // 26–33
      } else if (year >= 1996 && year <= 2005) {
        prefix = String(Math.floor(Math.random() * 6) + 33); // 33–38
      } else if (year >= 2006 && year <= 2008) {
        prefix = '38';
      } else {
        prefix = '38'; // fallback for out-of-band years
      }
      const yearDigits = String(year).slice(-2);
      // ID must be 8 digits: prefix (2) + yearDigits (2) + random (4)
      let nationalId;
      do {
        const randomDigits = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
        nationalId = `${prefix}${yearDigits}${randomDigits}`;
      } while (isDuplicateValue('nationalId', nationalId));
      window.generatedIds.add(nationalId);
      // Generate email
      let email;
      do {
        email = generateEmail(firstName, middleName, last.name, year);
      } while (isDuplicateValue('email', email));
      window.generatedEmails.add(email.toLowerCase());
      // Generate address
      const addressObj = generateAddress(county);
      const address = `P.O. Box ${addressObj.poBox} – ${addressObj.postalCode}\n${addressObj.subCounty}, ${addressObj.county} County`;
      return {
        ...mockPerson,
        lastName: last.name,
        gender,
        firstName,
        middleName,
        county,
        dob,
        nationalId,
        email,
        address,
        postalCode: addressObj.postalCode,
        poBox: addressObj.poBox,
        subCounty: addressObj.subCounty,
        phone,
        underlying_illness,
      };
    } else if (county === 'Kisii') {
      const last = getRandom(kisiiLastNames);
      const gender = last.gender.charAt(0).toUpperCase() + last.gender.slice(1);
      let firstName;
      if (gender === 'Female') {
        // Traditional Kisii: Moraa, Kerubo (20% chance)
        const traditional = ["Moraa", "Kerubo"];
        if (Math.random() < 0.2) {
          firstName = getRandom(traditional);
        } else {
          firstName = getRandom(femaleFirstNames.filter(n => !["Achieng", "Atieno"].includes(n)));
        }
      } else {
        // Traditional Kisii: Mose (20% chance)
        const traditional = ["Mose"];
        if (Math.random() < 0.2) {
          firstName = getRandom(traditional);
        } else {
          firstName = getRandom(maleFirstNames.filter(n => n !== "Ochieng"));
        }
      }
      // Middle name is random Kisii local name
      const middleName = getRandom(kisiiLocalNames);
      // Generate DOB and ID logic based on year of birth
      // Restrict year to 1951–2008 (ages 18–75 in 2026, min age 18)
      const year = Math.floor(Math.random() * (2008 - 1951 + 1)) + 1951;
      const month = String(Math.floor(Math.random() * 12) + 1).padStart(2, '0');
      const day = String(Math.floor(Math.random() * 28) + 1).padStart(2, '0');
      const dob = `${day}/${month}/${year}`;
      // ID logic with probabilistic prefix selection based on age cohort
      // 1951–1955: 10–11
      // 1956–1965: 11–15
      // 1966–1975: 12–18
      // 1976–1985: 19–25
      // 1986–1995: 26–33
      // 1996–2005: 33–38
      // 2006–2008: 38
      let prefix;
      if (year >= 1951 && year <= 1955) {
        prefix = String(Math.floor(Math.random() * 2) + 10); // 10–11
      } else if (year >= 1956 && year <= 1965) {
        prefix = String(Math.floor(Math.random() * 5) + 11); // 11–15
      } else if (year >= 1966 && year <= 1975) {
        prefix = String(Math.floor(Math.random() * 7) + 12); // 12–18
      } else if (year >= 1976 && year <= 1985) {
        prefix = String(Math.floor(Math.random() * 7) + 19); // 19–25
      } else if (year >= 1986 && year <= 1995) {
        prefix = String(Math.floor(Math.random() * 8) + 26); // 26–33
      } else if (year >= 1996 && year <= 2005) {
        prefix = String(Math.floor(Math.random() * 6) + 33); // 33–38
      } else if (year >= 2006 && year <= 2008) {
        prefix = '38';
      } else {
        prefix = '38'; // fallback for out-of-band years
      }
      const yearDigits = String(year).slice(-2);
      // ID must be 8 digits: prefix (2) + yearDigits (2) + random (4)
      let nationalId;
      do {
        const randomDigits = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
        nationalId = `${prefix}${yearDigits}${randomDigits}`;
      } while (isDuplicateValue('nationalId', nationalId));
      window.generatedIds.add(nationalId);
      // Generate email
      let email;
      do {
        email = generateEmail(firstName, middleName, last.name, year);
      } while (isDuplicateValue('email', email));
      window.generatedEmails.add(email.toLowerCase());
      // Generate address
      const addressObj = generateAddress(county);
      const address = `P.O. Box ${addressObj.poBox} – ${addressObj.postalCode}\n${addressObj.area}, ${addressObj.county} County`;
      return {
        ...mockPerson,
        lastName: last.name,
        gender,
        firstName,
        middleName,
        county,
        dob,
        nationalId,
        email,
        address,
        postalCode: addressObj.postalCode,
        poBox: addressObj.poBox,
        subCounty: addressObj.subCounty,
        phone,
        underlying_illness,
      };
    } else {
      // fallback: random gender
      const gender = Math.random() < 0.5 ? 'Male' : 'Female';
      let firstName;
      if (gender === 'Female') {
        firstName = getRandom(femaleFirstNames);
      } else {
        firstName = getRandom(maleFirstNames);
      }
      // Pick a random last name (surname)
      // You can adjust this to use your preferred surname array
      const randomSurnames = [
        "Otieno", "Omondi", "Ochieng", "Odhiambo", "Onyango", "Owuor", "Okeyo", "Ochola", "Obonyo", "Oburu",
        "Ouma", "Ogwang", "Omuga", "Rao", "Rawo", "Jow", "Nyang'au", "Oliech", "Otula", "Orweno", "Magero",
        "Julu", "Kidenda", "Kowa", "Hongo", "Oronge", "Oruoch", "Osuri", "Yienya", "Sialo", "Were",
        "Odiek", "Ooko", "Ogalo", "Omolo", "Owino", "Odalo", "Oduko", "Okumu", "Gor", "Jalang'o",
        "Meyo", "Ndiege", "Onango", "Obuo", "Ochuka", "Odede", "Raila", "Ramogi", "Ondiek", "Owiti",
        "Oloo", "Ogonji", "Odhon'g", "Odek", "Oduor", "Odongo", "Ouma", "Ogweyo", "Omuga", "Rao",
        "Rawo", "Jow", "Nyang'au", "Oliech", "Otula", "Orweno", "Hera", "Magero", "Julu", "Kidenda",
        "Kowa", "Hongo", "Oronge", "Oruoch", "Osuri", "Yienya", "Sialo", "Were", "Odiek", "Ooko",
        "Ogalo", "Omolo", "Owino", "Odalo", "Oduko", "Okumu", "Adida", "Ahenda", "Ajek", "Gor"
      ];
      const lastName = getRandom(randomSurnames);
      // Generate DOB and ID logic based on year of birth
      // Restrict year to 1951–2008 (ages 18–75 in 2026, min age 18)
      const year = Math.floor(Math.random() * (2008 - 1951 + 1)) + 1951;
      const month = String(Math.floor(Math.random() * 12) + 1).padStart(2, '0');
      const day = String(Math.floor(Math.random() * 28) + 1).padStart(2, '0');
      const dob = `${day}/${month}/${year}`;
      // ID logic with probabilistic prefix selection based on age cohort
      // 1951–1955: 10–11
      // 1956–1965: 11–15
      // 1966–1975: 12–18
      // 1976–1985: 19–25
      // 1986–1995: 26–33
      // 1996–2005: 33–38
      // 2006–2008: 38
      let prefix;
      if (year >= 1951 && year <= 1955) {
        prefix = String(Math.floor(Math.random() * 2) + 10); // 10–11
      } else if (year >= 1956 && year <= 1965) {
        prefix = String(Math.floor(Math.random() * 5) + 11); // 11–15
      } else if (year >= 1966 && year <= 1975) {
        prefix = String(Math.floor(Math.random() * 7) + 12); // 12–18
      } else if (year >= 1976 && year <= 1985) {
        prefix = String(Math.floor(Math.random() * 7) + 19); // 19–25
      } else if (year >= 1986 && year <= 1995) {
        prefix = String(Math.floor(Math.random() * 8) + 26); // 26–33
      } else if (year >= 1996 && year <= 2005) {
        prefix = String(Math.floor(Math.random() * 6) + 33); // 33–38
      } else if (year >= 2006 && year <= 2008) {
        prefix = '38';
      } else {
        prefix = '38'; // fallback for out-of-band years
      }
      const yearDigits = String(year).slice(-2);
      // ID must be 8 digits: prefix (2) + yearDigits (2) + random (4)
      const randomDigits = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
      const nationalId = `${prefix}${yearDigits}${randomDigits}`;
      // Generate email
      const email = generateEmail(firstName, '', lastName, year);
      // Generate address
      const addressObj = generateAddress(county);
      const address = `P.O. Box ${addressObj.poBox} – ${addressObj.postalCode}\n${addressObj.area}, ${addressObj.county} County`;
      return {
        ...mockPerson,
        gender,
        firstName,
        lastName,
        county,
        dob,
        nationalId,
        email,
        address,
        postalCode: addressObj.postalCode,
        poBox: addressObj.poBox,
        subCounty: addressObj.subCounty,
        phone,
        underlying_illness,
      };
    }
  }

  const [person, setPerson] = useState(generatePerson(hospitalCountyMap[selectedHospital]));
  const [copiedField, setCopiedField] = useState('');
  const [complete, setComplete] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);
  const [loading, setLoading] = useState(false);
  // Store generated patients for filtering
  const [patients, setPatients] = useState([person]);

  const handleCopy = (key) => {
    const value = person[key];
    if (window.navigator && window.navigator.clipboard && window.navigator.clipboard.writeText) {
      window.navigator.clipboard.writeText(value)
        .then(() => {
          setCopiedField(key);
          setTimeout(() => setCopiedField(''), 1200);
        })
        .catch(() => {
          fallbackCopy(value, key);
        });
    } else {
      fallbackCopy(value, key);
    }
  };

  function fallbackCopy(value, key) {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      setCopiedField(key);
      setTimeout(() => setCopiedField(''), 1200);
    } catch (err) {
      alert('Copy failed. Please copy manually.');
    }
    document.body.removeChild(textarea);
  }

  const handleGenerateNext = () => {
    setLoading(true);
    setTimeout(() => {
      // Generate only compatible patient
      let newPatient;
      do {
        newPatient = generatePerson(hospitalCountyMap[selectedHospital]);
      } while (newPatient.county !== hospitalCountyMap[selectedHospital]);
      setPatients([...patients, newPatient]);
      setPerson(newPatient);
      setComplete(false);
      setLoading(false);
    }, 1000);
  };

  const handleComplete = () => {
    const hasDuplicate =
      isDuplicateInCompleted('nationalId', person.nationalId) ||
      isDuplicateInCompleted('phone', person.phone) ||
      isDuplicateInCompleted('email', person.email);
    if (hasDuplicate) {
      alert('Duplicate detected (ID, phone, or email). Generating a new patient.');
      handleGenerateNext();
      return;
    }
    setComplete(true);
    // Mark as completed for stats
    const completedPatient = {
      ...person,
      completedAt: new Date(),
      hospital: selectedHospital
    };
    setCompletedPatients(prev => [
      ...prev,
      completedPatient
    ]);
    // Send to backend
    fetch('https://zaidoc.lynmercan.com/api/patients.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(completedPatient)
    })
      .then(res => res.json())
      .then(data => {
        if (!data.success) {
          alert('Failed to save patient to backend. Please try again.');
        }
      })
      .catch(err => {
        alert('Failed to save patient to backend. Please check your connection or try again.');
        console.error('Failed to save patient:', err);
      });
  };

  // Real stats from backend
  const [stats, setStats] = useState({ completedToday: 0, completedThisMonth: 0 });
  const [monthTarget, setMonthTarget] = useState(null);
  const [targetStartDate, setTargetStartDate] = useState(null);
  const [targetEndDate, setTargetEndDate] = useState(null);
  useEffect(() => {
    let intervalId;
    function fetchStats() {
      const now = new Date();
      const todayStr = now.toISOString().slice(0, 10);
      const monthStr = now.toISOString().slice(0, 7);
      const hospital = selectedHospital;
      // Fetch today count
      fetch(`https://zaidoc.lynmercan.com/api/patients.php?hospital=${encodeURIComponent(hospital)}&date=${todayStr}`)
        .then(res => res.json())
        .then(data => {
          setStats(prev => ({ ...prev, completedToday: data.count || 0 }));
        })
        .catch(() => setStats(prev => ({ ...prev, completedToday: 0 })));
      // Fetch month count
      fetch(`https://zaidoc.lynmercan.com/api/patients.php?hospital=${encodeURIComponent(hospital)}&month=${monthStr}`)
        .then(res => res.json())
        .then(data => {
          setStats(prev => ({ ...prev, completedThisMonth: data.count || 0 }));
        })
        .catch(() => setStats(prev => ({ ...prev, completedThisMonth: 0 })));
      // Fetch active target for today (date range)
      fetch(`https://zaidoc.lynmercan.com/api/patients.php?targets=1&hospital=${encodeURIComponent(hospital)}&date=${todayStr}`)
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data) && data.length > 0) {
            const targetValue = Number(data[0].target);
            setMonthTarget(Number.isFinite(targetValue) && targetValue > 0 ? targetValue : null);
            setTargetStartDate(data[0].start_date || null);
            setTargetEndDate(data[0].end_date || null);

            if (data[0].start_date && data[0].end_date) {
              fetch(`https://zaidoc.lynmercan.com/api/patients.php?hospital=${encodeURIComponent(hospital)}&start=${data[0].start_date}&end=${data[0].end_date}`)
                .then(res => res.json())
                .then(rangeData => {
                  setStats(prev => ({ ...prev, completedThisMonth: rangeData.count || 0 }));
                })
                .catch(() => setStats(prev => ({ ...prev, completedThisMonth: 0 })));
            }
          } else {
            setMonthTarget(null);
            setTargetStartDate(null);
            setTargetEndDate(null);
          }
        })
        .catch(() => {
          setMonthTarget(null);
          setTargetStartDate(null);
          setTargetEndDate(null);
        });
    }
    fetchStats();
    intervalId = setInterval(fetchStats, 10000); // Poll every 10 seconds
    return () => clearInterval(intervalId);
  }, [selectedHospital]);

  const [showTodayPage, setShowTodayPage] = useState(false);
  const [showMonthPage, setShowMonthPage] = useState(false);
  const [monthFilterDate, setMonthFilterDate] = useState("");
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showTargetModal, setShowTargetModal] = useState(false);
  const [plannedDaily, setPlannedDaily] = useState('');

  const now = new Date();
  const monthTargetValue = Number(monthTarget);
  const hasMonthTarget = Number.isFinite(monthTargetValue) && monthTargetValue > 0;
  const completedTodayValue = Number(stats.completedToday) || 0;
  const completedThisMonthValue = Number(stats.completedThisMonth) || 0;
  const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  const targetStartDateValue = targetStartDate ? new Date(`${targetStartDate}T00:00:00`) : null;
  const targetEndDateValue = targetEndDate ? new Date(`${targetEndDate}T00:00:00`) : null;
  const rangeTotalDays = targetStartDateValue && targetEndDateValue
    ? Math.max(Math.floor((targetEndDateValue - targetStartDateValue) / (24 * 60 * 60 * 1000)) + 1, 1)
    : daysInMonth;
  const daysRemaining = targetEndDateValue
    ? Math.max(Math.floor((targetEndDateValue - todayDate) / (24 * 60 * 60 * 1000)) + 1, 0)
    : Math.max(daysInMonth - now.getDate() + 1, 0);
  const daysElapsed = targetStartDateValue
    ? Math.max(Math.floor((todayDate - targetStartDateValue) / (24 * 60 * 60 * 1000)) + 1, 0)
    : now.getDate();
  const remainingToTarget = Math.max(monthTargetValue - completedThisMonthValue, 0);
  const requiredDailyPace = daysRemaining > 0 ? Math.ceil(remainingToTarget / daysRemaining) : remainingToTarget;
  const targetDueDate = targetEndDateValue || new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const plannedDailyValue = Number(plannedDaily);
  const hasPlannedDaily = Number.isFinite(plannedDailyValue) && plannedDailyValue > 0;
  const plannedDaysNeeded = hasPlannedDaily ? Math.ceil(remainingToTarget / plannedDailyValue) : null;
  const plannedFinishDate = plannedDaysNeeded ? new Date(now.getFullYear(), now.getMonth(), now.getDate() + plannedDaysNeeded - 1) : null;
  const projectedTotalByEnd = hasPlannedDaily ? completedThisMonthValue + (plannedDailyValue * daysRemaining) : null;

  const handleLogoutConfirm = () => {
    setShowLogoutConfirm(false);
    onLogout();
  };

  const logoutModal = showLogoutConfirm && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-96">
        <h3 className="text-lg font-bold mb-4">Confirm Logout</h3>

        {/* Performance Warning */}
        {hasMonthTarget && completedThisMonthValue < Math.ceil(monthTargetValue / rangeTotalDays) * Math.ceil(daysElapsed) - 2 && (
          <div className="mb-4 p-3 bg-yellow-50 border-l-4 border-yellow-500 rounded">
            <div className="text-yellow-700 font-semibold mb-2">⚠️ Performance Warning</div>
            {(() => {
              const dailyGoal = Math.ceil(monthTargetValue / rangeTotalDays);
              const expectedByNow = dailyGoal * Math.ceil(daysElapsed);
              const shortfall = expectedByNow - completedThisMonthValue;
              const requiredDailyPace = daysRemaining > 0 ? Math.ceil((monthTargetValue - completedThisMonthValue) / daysRemaining) : monthTargetValue;

              return (
                <div>
                  <p className="text-sm text-yellow-700 mb-2">
                    You're <span className="font-bold">{shortfall}</span> behind schedule. Need <span className="font-bold">{requiredDailyPace}</span> patients/day for the remaining <span className="font-bold">{daysRemaining}</span> days.
                  </p>
                  <p className="text-xs text-yellow-600">
                    Current: {completedThisMonthValue} of {monthTargetValue} | Daily Goal: {dailyGoal}
                  </p>
                </div>
              );
            })()}
          </div>
        )}

        <p className="text-gray-600 mb-6">Are you sure you want to logout?</p>
        <div className="flex gap-3 justify-end">
          <button
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
            onClick={() => setShowLogoutConfirm(false)}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            onClick={handleLogoutConfirm}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );

  const targetModal = showTargetModal && hasMonthTarget && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-lg font-bold">Monthly Target Calculator</h3>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={() => setShowTargetModal(false)}
            aria-label="Close"
          >
            X
          </button>
        </div>

        <div className="grid grid-cols-2 gap-4 text-sm mb-4">
          <div className="bg-gray-50 rounded p-3">
            <div className="text-gray-600">Completed</div>
            <div className="font-bold text-gray-900">{completedThisMonthValue}</div>
          </div>
          <div className="bg-gray-50 rounded p-3">
            <div className="text-gray-600">Target</div>
            <div className="font-bold text-gray-900">{monthTargetValue}</div>
          </div>
          <div className="bg-gray-50 rounded p-3">
            <div className="text-gray-600">Remaining</div>
            <div className="font-bold text-gray-900">{remainingToTarget}</div>
          </div>
          <div className="bg-gray-50 rounded p-3">
            <div className="text-gray-600">Days Remaining</div>
            <div className="font-bold text-gray-900">{daysRemaining}</div>
          </div>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded p-4 mb-4">
          <div className="text-sm text-blue-700">Required pace to hit target</div>
          <div className="text-xl font-bold text-blue-900">{requiredDailyPace} / day</div>
          <div className="text-xs text-blue-700 mt-1">Target due: {targetDueDate.toLocaleDateString()}</div>
        </div>

        <div className="border-t pt-4">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Your planned daily number
          </label>
          <input
            type="number"
            min="0"
            className="w-full border rounded px-3 py-2 mb-3"
            value={plannedDaily}
            onChange={e => setPlannedDaily(e.target.value)}
            placeholder="e.g. 25"
          />

          <div className="text-sm text-gray-700 space-y-2">
            <div>
              Projected total by month end: <span className="font-semibold">{hasPlannedDaily ? projectedTotalByEnd : '-'}</span>
            </div>
            <div>
              Estimated reach date: <span className="font-semibold">{plannedFinishDate ? plannedFinishDate.toLocaleDateString() : '-'}</span>
            </div>
          </div>

          {hasPlannedDaily && projectedTotalByEnd < monthTargetValue && (
            <div className="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded p-3">
              At this daily pace, you will not reach the target by the end of the month.
            </div>
          )}
        </div>

        <div className="flex justify-end mt-5">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
            onClick={() => setShowTargetModal(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );

  // Prompt before closing page if patient not completed
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      // Only prompt if there's an active patient and it's not completed
      if (person && !complete && !showDashboard && !showTodayPage && !showMonthPage) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [person, complete, showDashboard, showTodayPage, showMonthPage]);

  // Filter completed patients for today/month
  const todayStr = now.toISOString().slice(0, 10);
  const monthStr = now.toISOString().slice(0, 7);
  const completedTodayList = completedPatients.filter(p => {
    if (!p.completedAt) return false;
    const d = new Date(p.completedAt);
    return d.toISOString().slice(0, 10) === todayStr;
  });
  const completedMonthList = completedPatients.filter(p => {
    if (!p.completedAt) return false;
    const d = new Date(p.completedAt);
    return d.toISOString().slice(0, 7) === monthStr;
  });

  // Full page table component
  function CompletedTablePage({ patients, title, showDateFilter, filterDate, setFilterDate, onBack }) {
    let filtered = patients;
    if (showDateFilter && filterDate) {
      filtered = patients.filter(p => {
        const d = new Date(p.completedAt);
        return d.toISOString().slice(0, 10) === filterDate;
      });
    }
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center p-4">
        <div className="w-full max-w-2xl flex flex-col items-center mb-8">
          <button className="self-start mb-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600" onClick={onBack}>Back</button>
          <h3 className="text-2xl font-bold mb-4">{title}</h3>
          {showDateFilter && (
            <div className="mb-4">
              <label className="font-semibold mr-2">Filter by date:</label>
              <input type="date" value={filterDate} onChange={e => setFilterDate(e.target.value)} className="border rounded px-2 py-1" />
            </div>
          )}
          <div className="overflow-x-auto w-full">
            <table className="min-w-full border">
              <thead>
                <tr>
                  <th className="border px-2 py-1">Date</th>
                  <th className="border px-2 py-1">First Name</th>
                  <th className="border px-2 py-1">Middle Name</th>
                  <th className="border px-2 py-1">Last Name</th>
                  <th className="border px-2 py-1">Gender</th>
                  <th className="border px-2 py-1">DOB</th>
                  <th className="border px-2 py-1">National ID</th>
                  <th className="border px-2 py-1">Email</th>
                  <th className="border px-2 py-1">Phone</th>
                  <th className="border px-2 py-1">Illness</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan={10} className="text-center py-4">No records found.</td></tr>
                ) : (
                  filtered.map((p, i) => (
                    <tr key={i}>
                      <td className="border px-2 py-1">{new Date(p.completedAt).toLocaleDateString()}</td>
                      <td className="border px-2 py-1">{p.firstName}</td>
                      <td className="border px-2 py-1">{p.middleName}</td>
                      <td className="border px-2 py-1">{p.lastName}</td>
                      <td className="border px-2 py-1">{p.gender}</td>
                      <td className="border px-2 py-1">{p.dob}</td>
                      <td className="border px-2 py-1">{p.nationalId}</td>
                      <td className="border px-2 py-1">{p.email}</td>
                      <td className="border px-2 py-1">{p.phone}</td>
                      <td className="border px-2 py-1">{p.underlying_illness || p.illness || 'None'}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  // const [showDashboard, setShowDashboard] = useState(true);

  return (
    showDashboard ? (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center p-4">
        {logoutModal}
        {targetModal}
        {/* Top navigation bar */}
        <div className="w-full max-w-xl flex justify-between items-center mb-8">
          <button className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600" onClick={() => setShowDashboard(false)}>
            Back to Home
          </button>
          <button 
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            onClick={() => setShowLogoutConfirm(true)}
          >
            Logout
          </button>
        </div>
        <h2 className="text-2xl font-bold mb-6">Synthetic Person Record</h2>
        {/* Hospital selector removed */}
        <div className="w-full max-w-xl grid grid-cols-1 gap-3">
          {fieldOrder.map(({ key, label }) => (
            <div key={key} className="flex items-center bg-white rounded shadow p-3 justify-between hover:bg-blue-50 transition cursor-pointer" onClick={() => handleCopy(key)} tabIndex={0} aria-label={`Copy ${label}`}>
              <div>
                <span className="font-semibold text-gray-700">{label}:</span>
                <span className="ml-2 text-gray-900 text-lg">{person[key]}</span>
              </div>
              <div className="ml-2 flex items-center">
                {copiedField === key ? (
                  <span className="text-green-600 flex items-center"><CheckIcon className="w-5 h-5 mr-1" />Copied!</span>
                ) : (
                  <ClipboardIcon className="w-5 h-5 text-gray-400" />
                )}
              </div>
            </div>
          ))}
        </div>
        {/* Two buttons side by side, Generate Next disabled until Complete is clicked */}
        <div className="flex gap-4 mt-8 w-full max-w-xl">
          <button
            className="flex-1 bg-blue-600 text-white py-2 rounded font-semibold hover:bg-blue-700 disabled:opacity-60"
            onClick={handleGenerateNext}
            disabled={!complete || loading}
          >
            {loading ? 'Generating...' : 'Generate Next'}
          </button>
          <button
            className="flex-1 bg-red-600 text-white py-2 rounded font-semibold hover:bg-red-700 disabled:opacity-60"
            onClick={handleComplete}
            disabled={complete}
          >
            {complete ? 'Completed' : 'Complete'}
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-4">This record is synthetic and for testing or training use only.</p>
      </div>
    ) : showTodayPage ? (
      <CompletedTablePage
        patients={completedTodayList}
        title="Completed Today"
        showDateFilter={false}
        onBack={() => setShowTodayPage(false)}
      />
    ) : showMonthPage ? (
      <CompletedTablePage
        patients={completedMonthList}
        title="Completed This Month"
        showDateFilter={true}
        filterDate={monthFilterDate}
        setFilterDate={setMonthFilterDate}
        onBack={() => setShowMonthPage(false)}
      />
    ) : (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center p-4">
        {/* Top navigation bar */}
        <div className="w-full max-w-xl flex justify-between items-center mb-8">
          <button className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600" onClick={() => setShowDashboard(true)}>
            Back to Dashboard
          </button>
          <button 
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            onClick={() => setShowLogoutConfirm(true)}
          >
            Logout
          </button>
        </div>

        {logoutModal}
        {targetModal}

        <div className="w-full max-w-xl flex flex-col items-center">
          <h2 className="text-2xl font-bold mb-4">{selectedHospital}</h2>
          <div className="flex gap-8 mb-6">
            <div className="bg-white rounded shadow px-6 py-4 text-center cursor-pointer hover:bg-blue-100 transition-colors" onClick={() => setShowTodayPage(true)}>
              <div className="text-lg font-semibold text-gray-700">Completed Today</div>
              <div className="text-2xl font-bold text-blue-700">{completedTodayValue}</div>
            </div>
            <div className="bg-white rounded shadow px-6 py-4 text-center cursor-pointer hover:bg-blue-100 transition-colors" onClick={() => setShowMonthPage(true)}>
              <div className="text-lg font-semibold text-gray-700">
                {hasMonthTarget ? 'Completed in Target Range' : 'Completed This Month'}
              </div>
              <div className="text-2xl font-bold text-blue-700">{completedThisMonthValue}</div>
            </div>
          </div>
          
          {/* Animated Progress Bar for Monthly Target */}
          {hasMonthTarget && (
            <div
              className="w-full bg-white rounded-lg shadow-md p-6 mb-6 cursor-pointer"
              onClick={() => setShowTargetModal(true)}
              role="button"
              tabIndex={0}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') setShowTargetModal(true);
              }}
            >
              <style>{`
                @keyframes slideIn {
                  from { width: 0; }
                  to { width: var(--progress-width); }
                }
                @keyframes pulse {
                  0%, 100% { opacity: 1; }
                  50% { opacity: 0.7; }
                }
                .progress-bar-fill {
                  animation: slideIn 1s ease-out forwards;
                  height: 8px;
                  border-radius: 4px;
                  transition: background-color 0.3s ease;
                }
                .progress-bar-container {
                  position: relative;
                  background-color: #e5e7eb;
                  border-radius: 8px;
                  overflow: hidden;
                  height: 24px;
                }
                .progress-text {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  font-weight: bold;
                  font-size: 12px;
                  z-index: 10;
                }
              `}</style>
              <div className="mb-2 flex justify-between items-center">
                <h3 className="text-sm font-semibold text-gray-700">Target Progress ({rangeTotalDays} days)</h3>
                <span className="text-xs font-bold text-gray-600">{completedThisMonthValue}/{monthTargetValue}</span>
              </div>
              <div className="progress-bar-container">
                <div 
                  className="progress-bar-fill"
                  style={{
                    '--progress-width': `${Math.min((completedThisMonthValue / monthTargetValue) * 100, 100)}%`,
                    backgroundColor: completedThisMonthValue >= monthTargetValue 
                      ? '#10b981' 
                      : completedThisMonthValue >= monthTargetValue * 0.75
                      ? '#f59e0b'
                      : '#3b82f6'
                  }}
                />
                <div className="progress-text" style={{
                  color: completedThisMonthValue >= monthTargetValue * 0.5 ? '#ffffff' : '#374151'
                }}>
                  {Math.round((completedThisMonthValue / monthTargetValue) * 100)}%
                </div>
              </div>
              <div className="mt-2 text-xs text-gray-600">
                {completedThisMonthValue >= monthTargetValue 
                  ? '🎉 Target Reached!' 
                  : `${monthTargetValue - completedThisMonthValue} more to reach target`}
              </div>
              <div className="mt-1 text-xs text-gray-500">Target due: {targetDueDate.toLocaleDateString()}</div>
              {daysRemaining <= 10 && (
                <div className="mt-1 text-xs text-red-600 font-semibold">
                  {daysRemaining} days remaining to deadline
                </div>
              )}
            </div>
          )}

        </div>
      </div>
    )
  );
}

function AdminDashboard() {
  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <h2 className="text-xl font-bold mb-4">Admin Dashboard (Placeholder)</h2>
      {/* TODO: Add admin dashboard features */}
    </div>
  );
}

function App() {
  // Track logged-in hospital or admin, initialize from localStorage if present
  const [loggedInHospital, setLoggedInHospital] = useState(() => localStorage.getItem('loggedInHospital') || null);
  const [isAdmin, setIsAdmin] = useState(() => localStorage.getItem('isAdmin') === 'true');

  // Custom login page to set hospital
  function LoginWrapper() {
    const navigate = useNavigate();
    // Pass a callback to set hospital on successful login
    function handleLoginSuccess(hospitalName) {
      if (hospitalName === 'Admin') {
        setIsAdmin(true);
        localStorage.setItem('isAdmin', 'true');
        setLoggedInHospital(null);
        localStorage.removeItem('loggedInHospital');
        navigate('/admin');
      } else {
        setIsAdmin(false);
        localStorage.setItem('isAdmin', 'false');
        setLoggedInHospital(hospitalName);
        localStorage.setItem('loggedInHospital', hospitalName);
        navigate('/'); // Go to home page after login
      }
    }
    return <LoginPageWithHospital onLoginSuccess={handleLoginSuccess} />;
  }

  // Patch UserDashboard to receive hospital
  function UserDashboardWrapper() {
    function handleLogout() {
      setLoggedInHospital(null);
      localStorage.removeItem('loggedInHospital');
      setIsAdmin(false);
      localStorage.setItem('isAdmin', 'false');
    }
    return <UserDashboard loggedInHospital={loggedInHospital} onLogout={handleLogout} />;
  }

  function AdminWrapper() {
    function handleLogout() {
      setIsAdmin(false);
      localStorage.setItem('isAdmin', 'false');
    }
    // Dynamically import AdminPage from Admin.js
    const AdminPage = React.lazy(() => import('./Admin'));
    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <AdminPage onLogout={handleLogout} />
      </React.Suspense>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={isAdmin ? <Navigate to="/admin" /> : (loggedInHospital ? <UserDashboardWrapper /> : <LoginWrapper />)} />
        <Route path="/admin" element={isAdmin ? <AdminWrapper /> : <Navigate to="/" />} />
        <Route path="*" element={<Navigate to={isAdmin ? "/admin" : "/"} />} />
      </Routes>
    </Router>
  );
}

export default App;

// LoginPage component (restored)
function LoginPage({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  function validateEmail(email) {
    // Simple email regex
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
  }

  // Hardcoded hospital login details
  const hospitalLogins = {
    'Ablecare Hospital': {
      email: 'ablecare@zaidoc.com',
      password: 'Ablecare Hospital'
    },
    'Saye Hospital': {
      email: 'saye@zaidoc.com',
      password: 'Saye Hospital'
    },
    'Malela Hospital': {
      email: 'malela@zaidoc.com',
      password: 'Malela Hospital'
    },
    'A.A family hospital': {
      email: 'aafamilyhospital@zaidoc.com',
      password: 'A.A family hospital'
    },
    'Kendu Adventist Hospital': {
      email: 'kendudadventist@zaidoc.com',
      password: 'Kendu Adventist Hospital'
    },
    'Admin': {
      email: 'admin@zaidoc.com',
      password: 'ADMIN'
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Please fill in all fields.');
      return;
    }
    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    // Only allow hardcoded hospital logins
    const found = Object.values(hospitalLogins).find(
      cred => email.toLowerCase() === cred.email && password === cred.password
    );
    if (found) {
      // Find hospital name by email
      const hospitalName = Object.keys(hospitalLogins).find(
        name => hospitalLogins[name].email === email.toLowerCase()
      );
      if (onLoginSuccess) {
        onLoginSuccess(hospitalName);
      } else {
        navigate('/dashboard');
      }
    } else {
      setError('Invalid credentials. Use your hospital email and password.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">NaGen - National ID Generator</h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block font-semibold mb-1" htmlFor="email">Email</label>
            <input className="w-full border rounded px-3 py-2" type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="mb-6">
            <label className="block font-semibold mb-1" htmlFor="password">Password</label>
            <input className="w-full border rounded px-3 py-2" type="password" id="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          {error && <div className="mb-4 text-red-600 text-sm">{error}</div>}
          <button className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 font-semibold" type="submit">Login</button>
        </form>
      </div>
    </div>
  );
}

function LoginPageWithHospital(props) {
  return <LoginPage {...props} />;
}
